import React from "react";
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import "./App.css";
import EmailIcon from '@mui/icons-material/Email';

const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className="items">

          <div className="copyright">
            <h4>Copyright 2022 by Meghraj Thakre </h4>
           
          </div>
         
        </div>

        <div className="gmail">
              <a href="mailto: Meghrajthakre444@gamil.com">Send Mail </a>
              <EmailIcon/>
            </div>

          <div className="links-2">
            <a href="#"><InstagramIcon/></a>
            <a href="#"><FacebookIcon/></a>
            <a href="https://www.linkedin.com/in/meghraj-thakre-01a09b23a/"><LinkedInIcon/></a>
          </div>
      </div>
    </>
  );
};

export default Footer;
